const messageConfig = {
	FIELD_REQUIRED: 'FIELD_REQUIRED!',
	ERROR_HAS_OCCURRED: 'ERROR_HAS_OCCURRED!',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS!',
	SAVE_SUCCESS: 'SAVE_SUCCESS!',
	NUMBER_GREATER_THAN_0: 'NUMBER_GREATER_THAN_0!',
	NO_FIELDS_SELECTED: 'NO_FIELDS_SELECTED!',
};
export default messageConfig;
